import React, { useState, useRef } from 'react';
import { Align, Popup } from '@progress/kendo-react-popup';
import ClickOutHandler from './ClickOutComponent';

import { useHover } from '../../hooks/useHover';
import styled from 'styled-components';

type ItemDropdownProps = {
    title: (isActive: boolean, isPopupShow: boolean) => React.ReactNode;
    children: React.ReactNode;
    align?: 'right' | 'left';
    popupClass?: string;
    animationContainerClass?: string;
};
const Style = styled.div`
    &&& {
        .top-menu-dropdown__title {
            display: flex;
            cursor: pointer;
            padding-bottom: 5px;
        }
    }
`;

export const ItemDropdown: React.FC<ItemDropdownProps> = ({
    title,
    children,
    align = 'right',
    popupClass = '',
    animationContainerClass = '',
}: ItemDropdownProps) => {
    // hooks
    const [isPopupShow, setIsPopupShow] = useState(false);
    const [hoverRef, isHovered] = useHover();
    const anchorRef = useRef();

    // handlers
    function toggle() {
        setIsPopupShow((prev) => !prev);
    }

    // selectors
    const isActive = isPopupShow || isHovered;

    return (
        <ClickOutHandler
            onClickOut={() => {
                isPopupShow && toggle();
            }}
        >
            <Style>
                <div onClick={toggle} ref={hoverRef}>
                    {/*@ts-ignore*/}
                    <div className="top-menu-dropdown__title" ref={anchorRef as any}>
                        {title(isActive, isPopupShow)}
                    </div>
                </div>
                <Popup
                    anchor={anchorRef.current}
                    show={isPopupShow}
                    popupClass={`top-menu-dropdown__popup ${popupClass}`}
                    className={animationContainerClass || ''}
                    anchorAlign={{ horizontal: align, vertical: 'bottom' } as Align}
                    popupAlign={{ horizontal: align, vertical: 'top' } as Align}
                    style={{
                        visibility: isPopupShow ? 'visible' : 'hidden',
                    }}
                >
                    {children}
                </Popup>
            </Style>
        </ClickOutHandler>
    );
};
